const defaultState = {
  name: '',
  nameForClient: '',
  position: '',
  portionDivision: 1,
  codeV4: '',
};

export default defaultState;
